(function($) {
  $(document).ready(function() {

    if ($.fn.LazyLoad) {
      // LazyLoad
      var myLazyLoad = new LazyLoad();
    }

  });
})(jQuery);
